import { Play, Pause } from "lucide-react";
import { useSoundtrack, SOUNDTRACK_TITLE } from "@/contexts/SoundtrackContext";

/**
 * Minimal persistent indicator shown in the bottom corner once the soundtrack
 * has been started. Stays mounted site-wide so playback controls travel with
 * the visitor across routes.
 */
const FloatingSoundtrackIndicator = () => {
  const { isPlaying, hasStarted, toggle } = useSoundtrack();

  if (!hasStarted) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 animate-fade-in">
      <div className="flex items-center gap-2.5 rounded-full border border-[hsl(40_45%_55%)]/30 bg-[hsl(150_35%_8%)]/90 px-3 py-2 shadow-lg backdrop-blur-md">
        <button
          type="button"
          onClick={toggle}
          aria-label={isPlaying ? `Pause ${SOUNDTRACK_TITLE}` : `Play ${SOUNDTRACK_TITLE}`}
          className="flex h-6 w-6 items-center justify-center rounded-full text-[hsl(40_55%_72%)] transition-colors hover:text-[hsl(40_55%_85%)]"
        >
          {isPlaying ? (
            <Pause className="h-3.5 w-3.5" strokeWidth={1.5} />
          ) : (
            <Play className="h-3.5 w-3.5 translate-x-[1px]" strokeWidth={1.5} />
          )}
        </button>
        <span className="font-serif italic text-xs text-[hsl(40_40%_86%)] pr-1">
          {SOUNDTRACK_TITLE}
        </span>
      </div>
    </div>
  );
};

export default FloatingSoundtrackIndicator;
